var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12H12.375V6.6875C12.375 4.48281 10.7453 2.66094 8.625 2.35781V1.75C8.625 1.40469 8.34531 1.125 8 1.125C7.65469 1.125 7.375 1.40469 7.375 1.75V2.35781C5.25469 2.66094 3.625 4.48281 3.625 6.6875V12H3.25C2.97344 12 2.75 12.2234 2.75 12.5V13C2.75 13.0688 2.80625 13.125 2.875 13.125H6.25C6.25 14.0906 7.03438 14.875 8 14.875C8.96562 14.875 9.75 14.0906 9.75 13.125H13.125C13.1938 13.125 13.25 13.0688 13.25 13V12.5C13.25 12.2234 13.0266 12 12.75 12ZM8 13.875C7.58594 13.875 7.25 13.5391 7.25 13.125H8.75C8.75 13.5391 8.41406 13.875 8 13.875ZM4.75 12V6.6875C4.75 5.81875 5.0875 5.00312 5.70156 4.38906C6.31562 3.775 7.13125 3.4375 8 3.4375C8.86875 3.4375 9.68437 3.775 10.2984 4.38906C10.9125 5.00312 11.25 5.81875 11.25 6.6875V12H4.75Z",
    fill: "#262626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.ce4c1ca1.svg";
export { ForwardRef as ReactComponent };